module.exports = __webpack_public_path__ + "img/info.926e5c0e.svg";